<template>
  <div class="Page Map">

    <div class="Map__blur" :class="{ 'is-blur': tutorial }">
      <div class="Map__lang" @click="$root.langSwitch()">
        {{ lang == 'fr' ? 'en' : 'fr' }}
      </div>
      <div class="Map__info" @click="$store.commit('user/SET_TUTORIAL', true)" />

      <div class="Map__map-container">
        <div class="Map__map Vlazy" ref="map" :key="lang" v-lazy:background-image="require('./img/map_' + lang + '.jpg')">
            <div
              @click="markerSelected = marker"
              :key="marker"
              v-for="marker in $root.markers"
              class="Map__btn disable-force-touch"
              :class="['is-' + marker, { 'is-active': marker == markerSelected }]"
            >
                <transition name="Map__marker-inactive">
                  <img key="inactive" class="Map__marker-inactive" v-if="marker != markerSelected" :src="require('@/pages/marker/markers/' + marker + '/inactive.png')" />
                </transition>
                <transition name="Map__marker-active">
                  <img key="active" class="Map__marker-active" v-if="marker == markerSelected" :src="require('@/pages/marker/markers/' + marker + '/active.png')" />
                </transition>
            </div>

            <!--div class="Map__btn disable-force-touch is-singerb" :class="[{ 'is-active': markerSelected == 'singerb' }]" @click="markerSelected = 'singerb'">
              <transition name="Map__marker-inactive">
                <img key="inactive" class="Map__marker-inactive" v-if="markerSelected != 'singerb'" :src="require('@/pages/marker/markers/singer/inactive.png')" />
              </transition>
              <transition name="Map__marker-active">
                <img key="active" class="Map__marker-active" v-if="markerSelected == 'singerb'" :src="require('@/pages/marker/markers/singer/active.png')" />
              </transition>
            </div-->
        </div>
      </div>

      <router-link class="Map__selfie" :to="{ name: 'selfie.' + lang }">
        <img :src="require('./img/selfie.png')" />
      </router-link>

      <Cards :markerSelected="markerSelected" />

    </div>

    <Tutorial v-if="tutorial" />

  </div>
</template>

<script>
import Page from '@/core/mixins/Page'
import FooterComp from '@/components/footer/Footer'
import Cards from '@/components/cards/Cards'
import Tutorial from '@/components/tutorial/Tutorial'

export default {
  name: 'Map',
  components: { FooterComp, Tutorial, Cards },
  mixins: [Page],
  watch: {
    '$root.width': 'setMapSize',
    '$root.height': 'setMapSize',
  },
  computed: {
    tutorial() { return this.$store.getters['user/tutorial'] },
    markers() { return this.$store.getters['user/markers'] },
    nbOfMarker() { return _.size(_.filter(this.markers, m => m === true)) },
    shared() { return this.$store.getters['user/shared'] },
    isFacebook() { return this.$store.getters['user/isFacebook'] }
  },
  data: () => ({
    markerSelected: null
  }),
  created() {
    dataLayer.push({
      "useCaseStep": { "Id": "UCS539 - Game experience - Map page | PV", "trackType": "PV" },
      "event": "VPV",
      "page": {
        contentName: "experience",
        gaStep: "experience-map",
        requestURI: this.tracking.page.requestURI + "experience-map",
      },
      show: this.tracking.show
    })
  },
  mounted() {
    this.setMapSize()
  },
  methods: {
    setMapSize() {
      const scale = Math.min(
        this.$root.width / this.$refs.map.offsetWidth,
        this.$root.height / this.$refs.map.offsetHeight
      )

      TweenLite.set(this.$refs.map, { scale: scale })
    },
    loginFB() {
      FB.login(response => {
				if(response.authResponse) {
					FB.api('/me', {fields: 'name, email'}, response =>  {
						this.$store.commit('user/SET_FACEBOOK')
					})
				}
			}, {scope: 'email'})
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Map
  height 100%
  overflow hidden
  // background-image linear-gradient(to bottom, #d1cbc3 30%, #eae4dd 70%) // montreal
  // background #d5d2cb // chicoutimi
  background #e7e1d9 // toronto

  &__marker-inactive
  &__marker-active
    position absolute
    transform translateX(-50%)
    left 50%
    width 66px
    height 74px
    max-width 66px
    transition transform .5s, opacity .5s
    &-enter
    &-leave-active
      opacity 0
      transform translateX(-50%) scale(.5)

  &__marker-inactive
    width 40px
    height 40px

  &__lang
    position fixed
    right 20px
    top 27px
    color #41141D
    z-index 9999999999
    font-weight 700
    text-transform uppercase
    font-size 12px

  &__selfie
    position absolute
    right 75px
    top 200px
    width 84px
    z-index 9
    display block

  &__info
    width 25px
    height 25px
    background-image url('./img/info.png')
    position fixed
    left 20px
    top 20px
    background-size contain
    z-index 9

  &__blur
    transition filter 1s, transform 1s
    position relative
    height 100%
    &.is-blur
      filter blur(12px)
      transform scale(1.1)

  &__map-container
    height calc(100% - 60px)
    width 100%
    position relative
    margin-bottom 60px

  &__map
    width 375px
    height 528px
    background-size cover
    position absolute
    left 50%
    top -15px
    transform translate(-50%, 0%)

  &__btn
    position absolute
    width 40px
    height 40px
    &.is-trone
      top 108px
      right 80px
    // &.is-crown
    //   top 140px
    //   left 167px
    &.is-card
      top 150px
      left 170px
    &.is-mrfleur
      top 390px
      left 235px
    &.is-singer
      top 390px
      left 100px
    // &.is-singerb
    //   top 390px
    //   left 100px

</style>


